import { User } from "@/generated/client";
import { createSlice } from "@reduxjs/toolkit";

export interface UserTokens {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}

interface UserSlice {
  user: User;
  tokens: UserTokens;
}

const initialState = {
  user: {},
  tokens: {},
};

const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.tokens = action.payload;
    },
    clearUser: (state) => {
      state.user = {}
    },
    clearTokens: (state) => {
      state.tokens = {}
    }
  },
});

export const { setUser, setToken, clearTokens, clearUser } = UserSlice.actions;
export default UserSlice.reducer;
